import { useEffect, useState } from 'react';

const useCounterHook = ({ value, min, max, onChange }) => {
  const [state, setState] = useState({ count: value });
  useEffect(() => {
    setState({ count: value });
  }, [value]);
  useEffect(() => {
    onChange && onChange(state.count);
  }, [state.count]);
  const actions = {
    increment: () => {
      if (state.count < max) {
        setState({ count: state.count + 1 });
      }
    },
    decrement: () => {
      if (state.count > min) {
        setState({ count: state.count - 1 });
      }
    },
  };

  return { state, actions };
};

export default useCounterHook;
